package com.macrofocus.nastac.events

enum class EventMode {
    AUTO,MANUAL,ANIMATED
}